<template>
  <div
    id="app"
    :class="[
      { deliverableDetail: $route.name == 'deliverableDetail' || $route.name == 'weixin' || $route.name == 'toQrcode' },
      { ultraSmallSize: !(($route.name == 'odzid' && !getQuery('dataType')) || $route.name == 'zkzkid' || $route.name == 'onqid' || $route.name == 'oamid') },
      { newYearTheme: $store.state.NewYearTheme }
    ]"
    @dragover="handleDragover"
    @click="popHide"
  >
    <keep-alive exclude="SlideshowAllShow,OutLink">
      <!-- class="notranslate" 禁止翻译-->
      <router-view :key="$route.fullPath" v-if="allShow" />
    </keep-alive>
  </div>
</template>
<script>
import Bus from './bus.js'
export default {
  name: 'App',
  data() {
    return {
      screenWidth: window.innerWidth, //屏幕宽度
      allShow: false,
      promotionTypes: this.getQuery('promotionTypes')
    }
  },
  async created() {
    var _this = this
    _this.initStart()
    _this.setRem()

    //新年主题
    // this.setNewYearTheme();
  },
  mounted() {
    this.them()
    const _this = this
    window.$dataTime = new Date()

    window.$rightLeft = {
      left: '',
      center: '',
      right: ''
    }

    window.addEventListener('resize', (event) => {
      _this.setRem()
      _this.$store.commit('setWinWidth', window.innerWidth)
      _this.$store.commit('setWinHeight', window.innerHeight)
      _this.scring()
      _this.screenWidth = window.innerWidth
    })
    _this.scring()
    Bus.$on('reScring', () => {
      this.scring()
    })
  },
  computed: {
    isPC() {
      // return this.screenWidth >= 768 || this.screenWidth < 244
      return this.screenWidth > 768
    },
    // 外展、业务、邮箱、设备页面
    specialPage() {
      var link = window.location.href.split('?')[0],
        array = ['onqid', 'oamid', 'odzid', 'zkzkid'],
        flag = false
      if (array.filter((tags) => link.indexOf(tags) > -1).length) {
        flag = true
      }
      return flag
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == 'deliverableDetail') {
        var elm = document.getElementById('app')
        elm.removeAttribute('style')
      }
      if (from.name == 'deliverableDetail' && window.innerWidth >= 768 && window.innerWidth < 1200) {
        window.location.reload()
      }
    },
    isPC: function (val, oldVal) {
      //在PC端样式和移动端样式转换时刷新，除特殊页面外
      if (this.isSanbo() || this.$route.name == 'download' || this.$route.name == 'weixin' || this.$route.name == 'toQrcode' || this.IsMobile()) return
      window.location.reload()
    }
  },
  methods: {
    getRedDot() {
      this.$http.get('/im/api/chatsession.json', { createId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid'), receiveId: this.$store.state.CreatorInformation.length ? this.$store.state.CreatorInformation[0].userId : '' }).then((res) => {
        if (res.state == 1 && res.data && res.data.unReadNum > 0) {
          window.$redpoint = true
        }
      })
    },
    setNewYearTheme() {
      this.$store.commit('setNewYearTheme', 'bloodRed')
    },
    popHide() {
      //隐藏浮层
      Bus.$emit('popHide')
    },
    setRem() {
      if (!this.isPC) {
        const rem = document.documentElement.clientWidth / 75
        document.documentElement.style.fontSize = rem + 'px'
      }
    },
    isSanbo() {
      //是否为外展、设备、业务、邮箱页面进行特殊处理
      var name = window.location.pathname
      return name.indexOf('weixin') > -1 || name.indexOf('toQrcode') > -1 || name.indexOf('zkzkid') > -1 || name.indexOf('onqid') > -1 || name.indexOf('oamid') > -1 || name.indexOf('deliverableDetail') > -1 || (name.indexOf('odzid') > -1 && window.location.search.indexOf('dataType') == -1) || this.getQuery('brush')
    },
    handleDragover(ev) {
      ev.preventDefault()
    },
    initStart() {
      this.$http.get('/zciid-deliverable/showPlatformStyle/flow/api/get/getNameOrDiyPageName.json', { appId: this.$appId }).then((res) => {
        if (res.state == 1 && res.data) {
          window.$pfId = res.data.pfId || ''
          this.$store.commit('setCreateUserId', res.data.userId)
        } else {
          window.$pfId = ''
        }
        if (window.location.origin.indexOf('.19:') == -1) {
          this.isLoginState()
        } else {
          this.allShow = true
          this.isLoginState()
        }
      })
      //获取小元在线浮层接收人、助理等信息
      var array = ['ywId', 'deviceId', 'socialId', 'emailId'].filter((tags) => location.href.indexOf(tags) > -1),
        cid = this.getQuery(array[0])
      window.$cid = cid
      if (this.specialPage && array.length) {
        this.$http
          .get('/zciid-deliverable/api/issue/getAidList.json', {
            id: cid
          })
          .then((res) => {
            this.$store.commit('setReceiver', res.data)
          })
      }
    },
    them() {
      // window.document.title = '共享世界';
      //主题
      window.document.documentElement.setAttribute('data-theme', 'officialBlue')
    },
    //控制缩放
    scring() {
      if (this.IsMobile()) {
        return
      }
      var elm = document.getElementById('app'),
        scale = ((document.body.clientWidth + (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) ? 16 : 0) - (this.promotionTypes ? 0 : 16)) / 1200).toFixed(5)
      this.$store.commit('setScale', scale)
      if (this.isSanbo()) return
      //PC端缩放
      // if (window.innerWidth < 244 || (window.innerWidth >= 768 && window.innerWidth < 1200)) {
      if (window.innerWidth > 768 && window.innerWidth < 1200) {
        elm.setAttribute('style', '-webkit-transform:scale(' + scale + ');transform-origin:top left')
        document.querySelector('body').style.cssText = 'overflow-x:hidden'
        if (this.promotionTypes) {
          elm.style.height = window.innerHeight / scale + 'px'
        }
      } else {
        elm.style.removeProperty('transform')
      }
    },
    //除详情页外的四种页面
    fourPage() {
      if (this.specialPage && !(window.location.href.indexOf('appId') > -1 && window.location.search && !this.getQuery('pfId'))) {
        return true
      } else {
        return false
      }
    },
    //登录
    isLoginState() {
      var _this = this,
        wxud = localStorage.getItem('wxud') || '',
        noLoginSid = localStorage.getItem('noLoginSid') || ''
      _this.$http.get(window.location.origin + '/cme-sso-app/getCurrUserState.json', {}).then(async (res) => {
        if (res.state == 1 && noLoginSid != res.data.id) {
          _this.$store.commit('setLoginState', true)
          _this.getUserInfoByOpenId(res.data.id)
        } else {
          _this.handleLogoutOnly()
          _this.allShow = true
        }

        if (!(res.state == 1 && res.data.id) && !wxud) {
          //没有登录并且没有用户信息，获取用户信息
          async function recursion() {
            let resq = await _this.$http.get('/cme-sso-app/api/pfacc/codeId', { codeType: 'm' })
            if (resq.state != 1) return
            let res = await _this.$http.get('/cme-sso-app/api/pfacc/wxUser', { acc: resq.data })
            if (res.state != 1) {
              await recursion()
            } else {
              //成功
              wxud = resq.data
              noLoginSid = res.data.id
              localStorage.setItem('wxud', wxud)
              localStorage.setItem('noLoginSid', noLoginSid)
            }
          }
          await recursion()
        }
        if (_this.specialPage) {
          //获取创建人信息
          let CreatorInformation = await _this.$http.get('/acnid-project-approve//bsys/bsysrole//api/selectUserByPfIdAndAppIdAndDeliverId.json?', { deliverId: _this.$contentId ? _this.$contentId : _this.getQuery('communicationId') ? _this.getQuery('communicationId') : '', pfId: window.$pfId })

          if (CreatorInformation.state == 1) {
            _this.$store.commit('setCreatorInformation', CreatorInformation.data)
          }
          //获取小元在线小红点
          _this.getRedDot()
        }
      })
    },
    handleLogoutOnly() {
      this.$store.commit('setLoginState', false)
      this.$store.commit('setUserInfo', {})
      this.$store.commit('rightClickType', 531)
      this.$store.commit('setManageState', false)
      this.$store.commit('setRightMenu', { menu: [], append: [] })
      this.$store.state.rightMenu = []
    },
    //通过openId 获取用户信息
    getUserInfoByOpenId(id) {
      const _this = this
      _this.$http
        .get('/cme-sso-app/product/info/user/info.json', { userId: id })
        .then((res) => {
          if (res.state == 1) {
            _this.$store.commit('setUserInfo', res.data)

            _this.$http.get('/oqmid-pay-tool-web/app/api/inquiryMember.json', { userId: res.data.userId }).then((res) => {
              if (res.data != '0') {
                _this.$store.commit('setMemberLevel', res.data)
              }
            })
          }
        })
        .then(function () {
          _this.$http
            .get('/acnid-project-approve/bsysrole/checkAdmin/api/checkUserInSixRole.json', {
              appId: _this.$appId,
              userId: _this.$store.state.userInfo.userId
            })
            .then((reqs) => {
              if (reqs.state == 1 && reqs.data.length) {
                _this.$store.commit('setManageState', reqs.data[0].platformRole)
              }
            })
          ;(async () => {
            let type = '531'
            if (_this.$store.state.userInfo.userId) {
              let reqs = await _this.$http.get('/aassid/cms/client/api/getHangAppIds', { pfId: window.$pfId })
              var haveAppId
              //判断是否为外挂
              if (reqs.state == 1) {
                if (reqs.data.length && reqs.data.includes(_this.getQuery('appId'))) {
                  haveAppId = true
                }
              }
              let req = await _this.$http.get('/acnid-project-approve/circlestructure/businesscirclestructure/open/selectRoleByuserIdAndAppId.json', { userId: _this.$store.state.userInfo.userId, appId: _this.getQuery('appId') })
              //不是外挂并且在六级块,左上角点击增加参数
              if (!haveAppId && req.state == 1) {
                _this.$store.commit('iconAddPam', true)
              }

              if (top == self && !_this.IsApp().APP) {
                type = '532'
              } else {
                //客户端和APP有534
                if (req.state == 1) {
                  if (haveAppId) {
                    //是外挂
                    type = '533'
                  } else {
                    type = '534'
                  }
                } else {
                  type = '532'
                }
              }
              // _this.setCookie('userTypes', type, '/');
            }
            _this.$store.commit('rightClickType', type)
            _this.allShow = true
          })()
        })
    }
  }
  // ,
  // destroyed(){
  //   this.removeCookie('userTypes');
  // }
}
</script>
<style>
body {
  /* web页面放在移动端，点击button 标签或者添加了cursor:pointer 样式的标签，会出现 蓝色背景色， 解决方案 */
  -webkit-tap-highlight-color: transparent;
}
html,
body,
#app {
  height: 100%;
}
/* body{
  overflow-y: auto;
} */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* .lineHeight{
  line-height: 26px;
} */
/* 购物车、小元在线浮层 */
.supFloat {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  cursor: pointer;
}
.right-menu .el-cascader-menu {
  width: 127px !important;
}
.z-container {
  width: 1200px;
  margin: 0 auto;
}
.deliverableDetail {
  width: 100% !important;
}
/* layerOpen弹出框样式开始 */
.communication {
  position: fixed;
  bottom: 36px;
  /* right: 40px; */
  right: calc(100% - 290px);
  height: 372px;
  width: 260px;
  overflow: hidden;
  background-color: #fff;
  z-index: 99999;
}
.communication .layer-title,
.layer-show .layer-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #4398dd;
}
.communication .layer-title .title,
.layer-show .layer-title .title {
  padding-left: 20px;
}
.communication .layui-layer-setwin,
.layer-show .layui-layer-setwin {
  top: 8px;
}
.communication iframe,
.layer-show iframe {
  height: calc(100% - 30px);
  width: 100%;
}
.communication .layui-layer-setwin .layui-layer-max:hover {
  background-position: -32px -40px !important;
}
.communication .layui-layer-setwin .layui-layer-close1:hover {
  opacity: 1;
}
.communication .layui-layer-setwin .layui-layer-min:hover cite {
  background-color: #fff !important;
}
/* layerOpen弹出框样式结束 */

/* 过年主题 */
/* .head{
  background: url("./assets/nav_dragon_all.png") no-repeat top center;
} */
/* 过年主题 */
/*等比缩放 开始*/
/* @media screen and (min-width: 768px) and (max-width: 1200px),(max-width: 244px) { */
@media screen and (min-width: 769px) and (max-width: 1200px) {
  /* body {
    position: absolute;
    width: 100%;
    height: 100%;
  } */
  #app {
    transform-origin: 6px 0;
    width: 1200px;
  }
}
@media screen and (max-width: 767px) {
  .communication {
    height: 372px;
    width: 220px;
    right: calc(100% - 250px);
  }
}
@media screen and (max-width: 244px) {
  .ultraSmallSize {
    width: 244px !important;
  }
}
/* 弹窗样式开始 */
.personnel {
  width: 262px;
  display: flex;
  justify-content: space-between;
}
.personnel-btn {
  cursor: pointer;
  border-radius: 3px;
  color: #fff;
  border: 1px solid #2f8eed;
  background-color: #2f8eed;
}
.el-notification.right {
  right: calc(50% - 165px) !important;
}
/* 弹窗样式结束 */

/*安卓*/
.havrTransform.FontSizeZoomWholeAndroid1 {
  margin-top: 0;
  height: 97.828213%;
  transform: scale(1.0222);
  transform-origin: top left;
  width: 97.828213% !important;
}
.havrTransform.FontSizeZoomWholeAndroid2 {
  margin-top: 0;
  height: 89.110675%;
  transform: scale(1.1222);
  transform-origin: top left;
  width: 89.110675% !important;
}
.havrTransform.FontSizeZoomWholeAndroid3 {
  margin-top: 0;
  height: 79.649542%;
  transform: scale(1.2555);
  transform-origin: top left;
  width: 79.649542% !important;
}
.havrTransform.FontSizeZoomWholeAndroid4 {
  margin-top: 0;
  height: 73.773515%;
  transform: scale(1.3555);
  transform-origin: top left;
  width: 73.773515% !important;
}
.havrTransform.FontSizeZoomWholeAndroid5 {
  margin-top: 0;
  height: 67.168189%;
  transform: scale(1.4888);
  transform-origin: top left;
  width: 67.168189% !important;
}
.havrTransform.FontSizeZoomWholeAndroid6 {
  margin-top: 0;
  height: 62.5%;
  transform: scale(1.6);
  transform-origin: top left;
  width: 62.5% !important;
}

.open.FontSizeZoomWholeAndroid1 {
  transform: scale(1.0222);
  transform-origin: top right;
}
.open.FontSizeZoomWholeAndroid2 {
  transform: scale(1.1222);
  transform-origin: top right;
}
.open.FontSizeZoomWholeAndroid3 {
  transform: scale(1.2555);
  transform-origin: top right;
}
.open.FontSizeZoomWholeAndroid4 {
  transform: scale(1.3555);
  transform-origin: top right;
}
.open.FontSizeZoomWholeAndroid5 {
  transform: scale(1.4888);
  transform-origin: top right;
}
.open.FontSizeZoomWholeAndroid6 {
  transform: scale(1.6);
  transform-origin: top right;
}

/*IOS */
.havrTransform.FontSizeZoomWhole1 {
  margin-top: 0;
  height: 107.146683%;
  transform: scale(0.9333);
  transform-origin: top left;
  width: 107.146683% !important;
}
.havrTransform.FontSizeZoomWhole2 {
  margin-top: 0;
  height: 100%;
  transform: scale(1);
  transform-origin: top left;
  width: 100% !important;
}
.havrTransform.FontSizeZoomWhole3 {
  margin-top: 0;
  height: 91.844232%;
  transform: scale(1.0888);
  transform-origin: top left;
  width: 91.844232% !important;
}
.havrTransform.FontSizeZoomWhole4 {
  margin-top: 0;
  height: 86.542622%;
  transform: scale(1.1555);
  transform-origin: top left;
  width: 86.542622% !important;
}
.havrTransform.FontSizeZoomWhole5 {
  margin-top: 0;
  height: 79.649542%;
  transform: scale(1.2555);
  transform-origin: top left;
  width: 79.649542% !important;
}
.havrTransform.FontSizeZoomWhole6 {
  margin-top: 0;
  height: 68.184917%;
  transform: scale(1.4666);
  transform-origin: top left;
  width: 68.184917% !important;
}

.Anchor.FontSizeZoomWhole1 {
  transform: scale(0.9333);
  transform-origin: top right;
}
.Anchor.FontSizeZoomWhole2 {
  transform: scale(1);
  transform-origin: top right;
}
.Anchor.FontSizeZoomWhole3 {
  transform: scale(1.0888);
  transform-origin: top right;
}
.Anchor.FontSizeZoomWhole4 {
  transform: scale(1.1555);
  transform-origin: top right;
}
.Anchor.FontSizeZoomWhole5 {
  transform: scale(1.2555);
  transform-origin: top right;
}
.Anchor.FontSizeZoomWhole6 {
  transform: scale(1.4666);
  transform-origin: top right;
}
</style>
<style lang="scss">
.havrTransform.FontSizeZoomWholeAndroid6,
.havrTransform.FontSizeZoomWhole6 {
  .setShow {
    @media screen and (max-width: 645px) {
      width: auto !important;
    }
    @media screen and (max-width: 615px) {
      .toolbar .outcepillo {
        display: none !important;
      }
    }
    @media screen and (max-width: 560px) {
      width: 80px !important;
      .toolbar .exit {
        padding: 0 3px;
      }
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 645px) {
      display: none !important;
    }
  }

  .specialPage .nav-entrance {
    @media screen and (max-width: 460px) {
      display: none !important;
    }
  }
  .specialPage .toolbar-drop {
    @media screen and (max-width: 430px) {
      display: none !important;
    }
  }
}
.havrTransform.FontSizeZoomWholeAndroid5,
.havrTransform.FontSizeZoomWhole5 {
  .setShow {
    @media screen and (max-width: 615px) {
      width: auto !important;
    }
    @media screen and (max-width: 615px) {
      .toolbar .outcepillo {
        display: none !important;
      }
    }
    @media screen and (max-width: 560px) {
      width: 80px !important;
      .toolbar .exit {
        padding: 0 3px;
      }
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 615px) {
      display: none !important;
    }
  }
  .specialPage .nav-entrance {
    @media screen and (max-width: 440px) {
      display: none !important;
    }
  }
  .specialPage .toolbar-drop {
    @media screen and (max-width: 400px) {
      display: none !important;
    }
  }
}
.havrTransform.FontSizeZoomWholeAndroid4,
.havrTransform.FontSizeZoomWhole4 {
  .setShow {
    @media screen and (max-width: 565px) {
      width: auto !important;
    }
    @media screen and (max-width: 454px) {
      width: 80px !important;
      .toolbar .exit {
        padding: 0 3px;
      }
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 565px) {
      display: none !important;
    }
  }
  .specialPage .nav-entrance {
    @media screen and (max-width: 400px) {
      display: none !important;
    }
  }
  .specialPage .toolbar-drop {
    @media screen and (max-width: 370px) {
      display: none !important;
    }
  }
}
.havrTransform.FontSizeZoomWholeAndroid3,
.havrTransform.FontSizeZoomWhole3 {
  .setShow {
    @media screen and (max-width: 500px) {
      width: auto !important;
    }
    @media screen and (max-width: 421px) {
      width: 80px !important;
      .toolbar .exit {
        padding: 0 3px;
      }
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 500px) {
      display: none !important;
    }
  }
  .specialPage .nav-entrance {
    @media screen and (max-width: 370px) {
      display: none !important;
    }
  }
  .specialPage .toolbar-drop {
    @media screen and (max-width: 330px) {
      display: none !important;
    }
  }
}
.havrTransform.FontSizeZoomWholeAndroid2,
.havrTransform.FontSizeZoomWhole2 {
  .setShow {
    @media screen and (max-width: 470px) {
      width: auto !important;
    }
    @media screen and (max-width: 418px) {
      width: 80px !important;
      .toolbar .exit {
        padding: 0 3px;
      }
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 470px) {
      display: none !important;
    }
  }
  .specialPage .nav-entrance {
    @media screen and (max-width: 340px) {
      display: none !important;
    }
  }
}
.havrTransform.FontSizeZoomWholeAndroid1,
.havrTransform.FontSizeZoomWhole1 {
  .setShow {
    @media screen and (max-width: 400px) {
      width: auto !important;
    }
  }
  .icon-box {
    @media screen and (max-width: 786px) {
      display: none !important;
    }
  }
  .specialPage .nav-center {
    @media screen and (max-width: 400px) {
      display: none !important;
    }
  }
}
</style>
<style lang="scss">
@import '~@/assets/css/NewYearTheme.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue